// @flow
import React from 'react';
import './ProductGuide.scss';

const ProductGuide = () => (
  <section className="ProductGuide">
    <hr />
    <h3 className="product-guide__title">배송/결제/교환/반품 안내</h3>
    <h4 className="product-guide__subtitle">배송 정보</h4>
    <table className="product-guide__delivery-info">
      <tbody>
        <tr>
          <th>기본 배송비</th>
          <td>
            <ul>
              <li>- 배송비 3,850원 (부가세 포함)</li>
              <li>- 10만원 이상 구매시 배송비 무료</li>
              <li>- 도서산간 및 제주를 포함한 일부 지역 추가비용 발생</li>
              <li>- 장비의 경우 추가 배송비 및 설치비가 청구 될 수 있습니다</li>
            </ul>
          </td>
          <th className="exchange-return__desktop">교환/반품 배송비</th>
          <td className="exchange-return__desktop">
            <ul>
              <li>- 상품 별로 상이</li>
            </ul>
          </td>
        </tr>
        <tr>
          <th>착불 배송비</th>
          <td colSpan={3}>
            <ul>
              <li>- 착불 적용 상품에 개별 부과 (상품 별로 상이)</li>
            </ul>
          </td>
        </tr>
        <tr className="exchange-return__mobile">
          <th>교환/반품 배송비</th>
          <td>
            <ul>
              <li>- 상품 별로 상이</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
    <h4 className="product-guide__subtitle">결제 및 환불 안내</h4>
    <table className="product-guide__pay-return">
      <tbody>
        <tr>
          <th>결제 방법</th>
          <td>
            <ul>
              <li>- 신용카드</li>
              <li>- 가상계좌</li>
              <li>- 연구비카드</li>
              <li>- 세금계산서 (기업은행 033-502993-01-019)</li>
              <li>- 세금계산서 (신한은행 100-032-703829)</li>
              <li>- 상품 결제 후 최대 60일 이내 제공 완료</li>
            </ul>
          </td>
        </tr>
        <tr>
          <th>취소</th>
          <td>
            <ul>
              <li>- 취소 접수 후 3 ~ 5일 이내 환불 처리</li>
            </ul>
          </td>
        </tr>
        <tr>
          <th>반품</th>
          <td>
            <ul>
              <li>- 반품 접수 후 3 ~ 5일 이내 환불 처리</li>
            </ul>
          </td>
        </tr>
        <tr>
          <th>환급</th>
          <td>
            <ul>
              <li>
                - 회사는 회원이 구매신청한 상품 등이 품절 등의 사유로 인도 또는 제공할 수 없을
                때에는 지체 없이 그 사유를 회원에게 통지하고,
                <br />
                &nbsp;&nbsp;사전에 상품 등의 대금을 받은 경우에는 대금을 받은 날로부터 3영업일
                이내에 환급하거나 환급에 필요한 조치를 취합니다.
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <h4 className="product-guide__subtitle">교환 및 반품 접수</h4>
    <table>
      <tbody>
        <tr>
          <th>교환 및 반품 접수 기한</th>
          <td>
            <ul>
              <li>- 상품 수령일로부터 7일 이내</li>
            </ul>
          </td>
        </tr>
        <tr>
          <th>교환 및 반품 접수가 가능한 경우</th>
          <td>
            <ul>
              <li>
                - 제품의 하자는 없지만, 다른 상품으로 교환하거나 반품 원하는 경우
                <br />
                &nbsp;(배송비 고객 부담)
              </li>
              <li>- 상품자체 불량 및 하자에 의한 경우</li>
              <li>- 상품 오배송에 의한 경우</li>
            </ul>
          </td>
        </tr>
        <tr>
          <th>교환 및 반품 접수가 불가능한 경우</th>
          <td>
            <ul>
              <li>- 상품 수령 후 7일을 초과한 경우</li>
              <li>- 개별 포장 상품의 포장을 훼손한 경우</li>
              <li>- 고객의 고의적인 귀책으로 상품가치가 훼손된 경우</li>
              <li>- 주문제작을 통해서 제품을 생산하는 경우</li>
              <li>- 주문 당시 재고가 없어서 해외를 통해 제품을 수입해서 구매하는 경우</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <h4 className="product-guide__subtitle">교환 및 반품 신청</h4>
    <table>
      <tbody>
        <tr>
          <th>교환 절차</th>
          <td>
            <ul>
              <li>- 상품 불량/오배송/상품파손 </li>
              <li>- 전화(02-585-1342) 또는 info@cacheby.com에 상품교환 접수</li>
            </ul>
          </td>
        </tr>
        <tr>
          <th>반품 절차</th>
          <td>
            <ul>
              <li>
                - 반품할 품목을 확인 후 info@cacheby.com로 반품 신청 (수령 후 7일 이내 가능하며 이후
                불가)
              </li>
              <li>
                - 전달드린 주문번호와 함께 반품 상품을 포장
                <br />
                &nbsp;(포장을 꼼꼼하게 해주셔야 반품 상품 손상에 따른 불이익이 없습니다.)
              </li>
              <li>
                - 택배회사 방문 시 반품 상품 전달
                <br />
                &nbsp;(택배사의 반송장은 상품 교환이 완료될 때까지 보관해주시기 바랍니다.)
              </li>
              <li>
                - 회수된 제품 확인 후 하자없을시 배송비를 제외하고 환불 처리 진행
                <br />
                &nbsp;(환불 처리 후 입금까지 최대 2주까지 소요될 수 있습니다.)
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
);

export default ProductGuide;



// WEBPACK FOOTER //
// ./src/components/product/ProductGuide/ProductGuide.js